import React, { useEffect, createElement } from 'react';
import { Navigate } from 'react-router-dom';
export const LoginPage = () => {
  useEffect(() => {
    document.title = 'Sign In — Maestro Connect';
    let metaDescription = document.querySelector('meta[name="description"]') as HTMLMetaElement | null;
    if (!metaDescription) {
      metaDescription = document.createElement('meta');
      metaDescription.name = 'description';
      document.head.appendChild(metaDescription);
    }
    metaDescription.content = 'Sign in to your Maestro Connect account.';
  }, []);
  // The simplest approach is to redirect to the existing teacher login page
  return <Navigate to="/teacher-login" replace data-id="element-5612" />;
};